export var Name = 'accept-notification';
export var AcceptNotificationEvent = Name;